import { ChangeEvent, type JSX } from 'react'

import styles from './checkbox.module.scss'

type CheckboxProps = {
  label?: string | JSX.Element
  value?: string | number
  checked: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  id?: string
  className?: string
  isError?: boolean
  variant?: 'light' | 'alt'
}

const Checkbox = ({
  label,
  checked,
  value,
  onChange,
  disabled,
  id,
  className,
  isError = false,
  variant = 'light',
}: CheckboxProps): JSX.Element => (
  <label className={[styles['checkbox-container'], styles[variant], className].join(' ')}>
    <span className={styles.label}>{label}</span>
    <input type="checkbox" value={value} checked={checked} onChange={onChange} disabled={disabled} id={id} />
    <span
      className={`${styles.checkmark} ${styles[variant]}${disabled ? ` ${styles.disabled}` : ''}${
        isError ? ` ${styles.error}` : ''
      }`}
    ></span>
  </label>
)

export default Checkbox
